import { lazy } from 'react';

// project imports
import MainLayout from 'layout/MainLayout';
import Loadable from 'ui-component/Loadable';
import AuthGuard from 'utils/route-guard/AuthGuard';

// sample page routing
// const Products = Loadable(lazy(() => import('views/products')));
const Manufacturers = Loadable(lazy(() => import('views/manufacturers')));
// const Tools = Loadable(lazy(() => import('views/tools')));
const Tools = Loadable(lazy(() => import('views/tools')));
const Techniques = Loadable(lazy(() => import('views/techniques')));
const Events = Loadable(lazy(() => import('views/events')));
const Sponsors = Loadable(lazy(() => import('views/sponsors')));
const Users = Loadable(lazy(() => import('views/users')));
const About = Loadable(lazy(() => import('views/about')));
const ToolLevels = Loadable(lazy(() => import('views/tool-levels')));
const Analytics = Loadable(lazy(() => import('views/analytics')));

const MainRoutes = {
  path: '/',
  element: (
    <AuthGuard>
      <MainLayout />
    </AuthGuard>
  ),
  children: [
    // {
    //   path: '/products',
    //   element: <Products />,
    // },
    {
      path: '/manufacturers',
      element: <Manufacturers />,
    },
    {
      path: '/analytics', // Add this new route
      element: <Analytics />,
    },
    {
      path: '/tools',
      element: <Tools />,
    },
    {
      path: '/tool-levels',
      element: <ToolLevels />,
    },
    {
      path: '/techniques',
      element: <Techniques />,
    },
    {
      path: '/events',
      element: <Events />,
    },
    {
      path: '/sponsors',
      element: <Sponsors />,
    },
    {
      path: '/users',
      element: <Users />,
    },
    {
      path: '/about',
      element: <About />,
    },
  ],
};

export default MainRoutes;
